import React, { useState } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { i18n } from "../../../../../../localization/i18n";
import { showToast } from "../../../../../../components/CustomToast";
import api from "../../../../../../services/api";
import { IAuthFormData, IPersonFormData, ICheckoutData } from "../../dtos.d";
import { OutlinedInput } from "../../../../../../components/OutlinedInput";
import {
  Container,
  SuccessIcon,
  Title,
  SubTitle,
  FormCard,
  SubmitButton,
  InputsContainer,
} from "./styles";

interface StepSuccessProps {
  authFormData: IAuthFormData | undefined;
  setAuthFormData: any;
  personFormData: IPersonFormData | undefined;
  checkoutData: ICheckoutData | undefined;
  loading: boolean;
  setLoading: any;
  prevStep: () => void;
  transactionCode: string;
}

export function StepSuccess({
  authFormData,
  setAuthFormData,
  personFormData,
  checkoutData,
  loading,
  setLoading,
  prevStep,
  transactionCode
}: StepSuccessProps) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleFinalizeAccount = async () => {
    if (!password || password.length < 6) {
      showToast({ type: "error", message: "A senha deve ter no mínimo 6 caracteres." });
      return;
    }

    if (password !== confirmPassword) {
      showToast({ type: "error", message: "As senhas não coincidem." });
      return;
    }

    setLoading(true);
    try {
      const userEmail = personFormData?.email || "";

      const body = {
        email: userEmail,
        password: password,
        transaction_code: transactionCode
      };
      
      const response = await api.post("/fixiters/activate", body);
      
      const { token, refresh_token } = response.data;

      localStorage.setItem("@FixitApp:token", token);
      localStorage.setItem("@FixitApp:refresh_token", refresh_token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      showToast({ type: "success", message: "Conta ativada com sucesso! Redirecionando..." });
      
      window.location.href = "/";
      
    } catch (error: any) {
      showToast({ type: "error", message: error?.response?.data?.message || "Erro ao ativar conta. Entre em contato com o suporte." });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <SuccessIcon>
        <FiCheckCircle />
      </SuccessIcon>
      <Title>{i18n.t("fixiterRegistration.step3.title") as string}</Title>
      <SubTitle>
        {(i18n.t("fixiterRegistration.step3.subtitle") as string).replace('{{name}}', personFormData?.name?.split(" ")[0] || "Fixiter")}
      </SubTitle>

      <FormCard>
        <div style={{ textAlign: "center", marginBottom: "8px" }}>
          <h3 style={{ fontSize: "18px", color: "var(--black)" }}>{i18n.t("fixiterRegistration.step3.formTitle") as string}</h3>
          <p style={{ fontSize: "14px", color: "var(--gray)", marginTop: "4px" }}>
            {i18n.t("fixiterRegistration.step3.formDesc") as string} <strong>{personFormData?.email}</strong>
          </p>
        </div>

        <InputsContainer>
          <OutlinedInput
            inputName="password"
            label={i18n.t("fixiterRegistration.step3.passwordLabel") as string}
            value={password}
            handleChange={(val) => setPassword(val)}
            type="password"
          />

          <OutlinedInput
            inputName="confirmPassword"
            label={i18n.t("fixiterRegistration.step3.confirmPasswordLabel") as string}
            value={confirmPassword}
            handleChange={(val) => setConfirmPassword(val)}
            type="password"
          />
        </InputsContainer>

        <SubmitButton 
          onClick={handleFinalizeAccount} 
          disabled={loading || !password || password !== confirmPassword}
        >
          {loading ? "Criando conta..." : (i18n.t("fixiterRegistration.step3.buttonAccess") as string)}
        </SubmitButton>
      </FormCard>
    </Container>
  );
}